import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { SkuInventoryLabelStackContentViewModel } from './sku-inventory-label-stack-content-view-model';
import { PrintLabelContentComponent } from '../../print-label-content.component';

@Component({
  selector: 'app-sku-inventory-label-stack-content',
  templateUrl: './sku-inventory-label-stack-content.component.html',
  styleUrl: './sku-inventory-label-stack-content.component.scss',
  providers: [SkuInventoryLabelStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SkuInventoryLabelStackContentComponent extends PrintLabelContentComponent {
  constructor(
    public viewModel: SkuInventoryLabelStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
